import Req from '../../$axios';

const serviceModule = {
  // 获取大部门及相关人员架构信息功能
  getDepartmentUser(params) {
    return Req({
      url: 'department/getdepartmentuser/',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 部门列表
  getDepartmentIndex(params) {
    return Req({
      url: 'departments/departmentIndex',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 新增部门信息
  addDepartment(params) {
    return Req({
      url: 'departments/store',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 删除部门
  deleteDepartment(params) {
    return Req({
      url: 'departments/delete',
      method: 'delete',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 更新部门信息
  updateDepartment(params) {
    return Req({
      url: 'departments/update',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 部门分类信息
  departmentTypeList(params) {
    return Req({
      url: 'departmentCategory/index',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  changeEmployeesDepartment(params) {
    return Req({
      url: 'departments/changeEmployeesDepartment',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  searchDepartment(params) { // 搜索部门
    return Req({
      url: 'departments/searchDepartment',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  getMyManagementDepartmentCategoryIndex(params) {
    return Req({
      url: 'departmentCategory/getMyManagementDepartmentCategoryIndex',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 获取所有人员及所在部门信息 （用于添加人员时显示）
  getAllDepartmentUser(params) {
    return Req({
      url: 'department/getAllDepartmentUser',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  }
};

export default {
  ...serviceModule
};
